//File imports
import {
    PAGINATION_DEFAULT_LIMIT,
    PAGINATION_DEFAULT_PAGE,
} from '../../../Constant';
import HttpService from '../../../services/Http/HttpService';
import Logger from '../../../services/Logger/Logger';
import { API_GET_ALL_DOCUMENT_DRAFTS } from './DraftConstants';
import DraftResultsPojo from './DraftResultPojo';

export class DraftService {
    private httpService = new HttpService();
    private logger = new Logger();

    async getAllWithPagination(
        page: number = PAGINATION_DEFAULT_PAGE,
        limit: number = PAGINATION_DEFAULT_LIMIT,
        showDevDrafts: boolean = false,
    ): Promise<DraftResultsPojo> {
        try {
            const httpResult = await this.httpService.get(
                API_GET_ALL_DOCUMENT_DRAFTS,
                {
                    page: page,
                    limit: limit,
                    showDevDrafts: showDevDrafts,
                },
            );
            return {
                isSuccess: httpResult.data.isSuccess,
                drafts: httpResult.data.response,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }
}
